var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    id: "svg8",
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1871",
    style: {
      display: "inline"
    },
    transform: "translate(0,-290.65039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12,292.65039 c -5.511,0 -10,4.489 -10,10 0,5.511 4.489,10 10,10 5.511,0 10,-4.489 10,-10 0,-5.511 -4.489,-10 -10,-10 z m 0,2 c 4.43012,0 8,3.56988 8,8 0,4.43012 -3.56988,8 -8,8 -4.43012,0 -8,-3.56988 -8,-8 0,-4.43012 3.56988,-8 8,-8 z",
    id: "circle1856",
    style: {
      color: "#65bb5a",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#65bb5a",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#65bb5a",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#65bb5a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.20508,299.04492 -3.87695,5.08789 -2.61915,-2.6289 c -0.3894,-0.39153 -1.02245,-0.39332 -1.41406,-0.004 -0.3915,0.38943 -0.39325,1.02247 -0.004,1.41406 l 3.42969,3.44141 c 0.42787,0.42948 1.13641,0.38256 1.50391,-0.0996 l 4.57031,-6 c 0.33395,-0.43914 0.24918,-1.06577 -0.18945,-1.40039 -0.43349,-0.3094 -1.0354,-0.26926 -1.40039,0.18953 z",
    id: "path1867",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#65bb5a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000000",
      stopOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.1ed57cf6da9b0896c8ab115739c9f524.svg";
export { ForwardRef as ReactComponent };